import React from 'react';
import skyline from '../images/Skyline.gif';
import grass from '../images/grass-1x.jpg';
import grass2x from '../images/grass-2x.jpg';
import Image from 'next/image';
const GifLoader = ({imgalt,grassimgalt}) => {
  return (
    <div>
       <Image src={skyline}  alt={imgalt?imgalt:"giufalter"} />
       <Image className='mt-[-1px]' src={grass2x} alt={grassimgalt?grassimgalt:"grass"} />
        {/* <img className='mt-[-1px]' src={grass} alt="grass" 
           srcSet={`${grass} 1x, ${grass2x} 2x`}
          /> */}
    </div>
  );
};
{/* <GifLoader src1x="path/to/your/gif_1x.gif" src2x="path/to/your/gif_2x.gif" alt="Loading GIF" /> */}
export default GifLoader;